import { defaultUiParameters } from '@openx/utils/services/optionsService';

import pckg from '../package.json';

const demo = new URLSearchParams(window.location.search).has('demo');
const googleMockDomain = 'http://localhost:5000';
const environment = import.meta.env.MODE || 'development';

export const CTA_VERSION = pckg.version;

export const MSG_ORIGIN_DISABLED = import.meta.env.VITE_NX_PUBLIC_REACT_APP_MSG_ORIGIN_DISABLED === 'true';
export const GOOGLE_MOCKED_DATA = demo || import.meta.env.VITE_NX_PUBLIC_REACT_APP_GOOGLE_MOCKED_DATA === 'true';

export const ALLOWED_DOMAINS = (environment === 'development' ? [googleMockDomain] : []).concat([
  'https://admanager.google.com',
  'https://admob.google.com',
  'https://apps.admob.com',
  'https://zipline.appspot.com',
  'http://admanager-ics.corp.google.com',
  'https://admanager-ics.corp.google.com',
  'http://ics.corp.google.com',
  'https://ics.corp.google.com',
]);
export const ALLOWED_DOMAINS_GROUP = '.corp.google.com';

export const GA_TRACKING_ID = 'G-NQFL1C96D8';

export const GA_ORIGIN_DOMAIN = 'contracts.openx.com';

export const GOOGLE_VERSION = 'v2';

export const GROWTHBOOK_API_HOST = defaultUiParameters.growthbookApiHost;
export const GROWTHBOOK_API_KEY = defaultUiParameters.growthbookApiKey;
export const GROWTHBOOK_NAME_ATTR = `${pckg.name}`;
